const { __ } = wp.i18n;
const { Component, Fragment } = wp.element;

const {
  PanelBody,
  PanelRow,
  SelectControl,
  TextareaControl,
  ToggleControl,
  TextControl
} = wp.components;
const { AlignmentToolbar } = wp.editor;
export default class Settings extends Component {
  constructor() {
    super(...arguments);
  }
  render() {
    const {
      attributes: { theme, front, tweet, IncludePageLink, IncludeVia, showTweetButton },
      setAttributes
    } = this.props;
    return (
      <Fragment>
        <PanelBody
          title={__("Theme")}
          initialOpen={true}
          className={"ssb_panel_wrapper"}
        >
          <PanelRow>
            <SelectControl
              value={theme}
              options={[
                { label: "Round", value: "twitter-round" },
                { label: "Dark", value: "twitter-dark" },
                { label: "Simple", value: "simple-twitter" },
                { label: "Side line", value: "twitter-side-line" },
                { label: "Own Style", value: "" },
              ]}
              onChange={theme => setAttributes({ theme })}
              help={"select the style for click to tweet "}
            />


          </PanelRow>
        </PanelBody>
        <PanelBody
          title={__("Content")}
          initialOpen={true}
          className={"ssb_panel_wrapper"}
        >
          <PanelRow>
            <TextareaControl
              label={__("Quote Content")}
              value={front}
              help={__("This text will be shown to the user.")}
              onChange={front => setAttributes({ front })}
            />
            <TextareaControl
              label={__("Tweet Content")}
              value={tweet}
              help={__("This text will be tweet . if empty Quote content will be used.")}
              onChange={tweet => setAttributes({ tweet })}
            />
          </PanelRow>
        </PanelBody>

        <PanelBody
          title={__(" Configuration")}
          initialOpen={false}
          className={"ssb_panel_wrapper"}
        >
          <PanelRow>
            <ToggleControl
              label={__('Show Tweet Button')}
              checked={showTweetButton}
              onChange={showbtn => { setAttributes({ showTweetButton: !!showbtn }) }}
            />
            <ToggleControl
              label={__('Include Page/post Link')}
              checked={IncludePageLink}
              onChange={pageLink => { setAttributes({ IncludePageLink: !!pageLink }) }}
              help={__('\n Link to this post will be appended to the Tweet. we have a filter if you want to modify it `ssb_ctt_url`.')}
            />
            <ToggleControl
              label={__('Include Via')}
              checked={IncludeVia}
              onChange={via => { setAttributes({ IncludeVia: !!via }) }}
              help={__('\n Twitter username from SSB Settings Advanced tab will be appended to the end of the Tweet with the text “via @username”.')}
            />

          </PanelRow>
        </PanelBody>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// blocks/click-to-tweet/settings.js